// Lazy videos rendered by snippets/lazy-video.liquid.
// - The file is only requested when the <video> is on (or near) the screen and
//   rendered: copies hidden with display:none never intersect, so they never load.
// - Videos pause when they leave the screen, so only what is visible is decoding.
// - If the browser blocks autoplay (e.g. iOS Low Power Mode) the poster stays.
(() => {
  if (window.lazyVideo) return;

  const load = video => {
    if (video.dataset.lazyLoaded) return;
    video.dataset.lazyLoaded = 'true';
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.preload = 'auto';
    video.load();
  };

  const play = video => {
    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  };

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          load(video);
          if ('autoplay' in video.dataset) play(video);
        } else if (video.dataset.lazyLoaded && !video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  const observe = (root = document) => {
    root.querySelectorAll('video[data-lazy-video]').forEach(video => observer.observe(video));
  };

  window.lazyVideo = { observe };
  observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
